import Cookie from 'js-cookie';

import {
  skuSelected,
  freeTrialSelected,
  subscriptionSelected,
  subscriptionRequested,
  skipFreeTrialSet,
} from 'app/features/products/actions';
import {
  isSelectedProductWithOnePlan,
  productPlanSku,
} from 'app/features/products/selectors';
import { actionDetail } from 'app/features/landing/productComparison/selectors';
import { isDirectToPay } from 'app/features/user/selectors';
import {
  COOKIE_EXPIRATION_ONE_YEAR,
  CR_FT_COOKIE,
  CR_PLUS_CTA_COOKIE,
  CR_PREM_PLUS_COOKIE,
} from 'app/features/landing/constants';
import domainFromHostname from 'app/router/helpers/domainFromHostname';
import { isMigrationCouponFlow } from 'app/features/migration/landing/selectors';

const dispatchSubscriptionEvents = (dispatch, getState, props) => {
  const eventPayload = {
    sku: productPlanSku(getState(), props),
    ...actionDetail(getState(), props),
  };

  dispatch(subscriptionSelected(eventPayload));

  if (isSelectedProductWithOnePlan(getState(), props)) {
    dispatch(subscriptionRequested(eventPayload));
  }
};

const productCtaClicked = props => (dispatch, getState) => {
  const { sku, lengthOfFreeTrial } = props;
  const state = getState();

  dispatch(skuSelected(sku));

  if (isDirectToPay(state) && !isMigrationCouponFlow(state)) {
    dispatchSubscriptionEvents(dispatch, getState, props);
  } else {
    const eventPayload = {
      sku,
      lengthOfFreeTrial,
      ...actionDetail(state, props),
    };

    dispatch(freeTrialSelected(eventPayload));
  }
};

const skipFreeTrialClicked = props => (dispatch, getState) => {
  const { sku } = props;

  dispatch(skipFreeTrialSet());
  dispatch(skuSelected(sku));

  dispatchSubscriptionEvents(dispatch, getState, props);
};

const setCrPlusCtaMembershipCookie = () => {
  const domain = domainFromHostname();

  Cookie.set(CR_PLUS_CTA_COOKIE, 1, {
    domain,
    expires: COOKIE_EXPIRATION_ONE_YEAR,
  });
};

const setCrPremPlusCookie = () => {
  const domain = domainFromHostname();

  Cookie.set(CR_PREM_PLUS_COOKIE, 1, {
    domain,
    expires: COOKIE_EXPIRATION_ONE_YEAR,
  });
};

const setCrFreeTrialCookie = () => {
  const domain = domainFromHostname();

  Cookie.set(CR_FT_COOKIE, 1, { domain, expires: COOKIE_EXPIRATION_ONE_YEAR });
};

export {
  skipFreeTrialClicked,
  productCtaClicked,
  setCrPlusCtaMembershipCookie,
  setCrPremPlusCookie,
  setCrFreeTrialCookie,
};
